import { css as a, styled as e } from "styled-components";
import { Theme as t } from "../../styles/themes/index.js";
import { CaptionLight as n, BodyHeavy as g, H3Heavy as s } from "../../styles/typography/index.js";
import { Image as h } from "../Image/index.js";
import { clampMixin as i } from "../../styles/shared/index.js";
import { Skeleton as p } from "../Skeleton/index.js";
import { TextSkeleton as o } from "../TextSkeleton/index.js";
import { MediaQuery as r } from "../../styles/variables.js";
const m = a`
  grid-area: image;
  width: 80px;
  min-width: 80px;
  height: 80px;
  min-height: 80px;
  border-radius: 4px;
`, d = a`
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  border-radius: 4px;
`, y = e.div`
  background: rgb(${t.colors.Juliet});
  border: 1px solid rgb(${t.colors.Golf});
  color: rgb(${t.colors.Alpha});
  border-radius: 16px;
  padding: 16px;
  display: grid;
  column-gap: 12px;
  row-gap: 8px;
  grid-template-areas:
    'header header'
    'info image';
  align-items: center;
  justify-content: space-between;
  grid-template-columns: 1fr auto;

  @container ${r.SCREEN_MD_UP} {
    row-gap: 12px;
    grid-template-areas:
      'header image'
      'info image';
  }
`, b = e.div`
  display: flex;
  align-items: center;
  grid-area: header;
  justify-content: space-between;
  min-height: 34px;

  @container ${r.SCREEN_MD_UP} {
    justify-content: flex-start;
    column-gap: 20px;
  }
`, k = e.div`
  display: flex;
  align-items: center;
  gap: 8px;

  span {
    ${n}

    // lineHeight same as CaptionLight
    ${i(1, 1.125)}
  }

  picture {
    ${d}
    img {
      width: 100%;
      height: 100%;
    }
  }
`, v = e.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  grid-area: info;

  p {
    ${n}
    // lineHeight same as CaptionLight
    ${i(2, 1.125)}

    @container ${r.SCREEN_MD_UP} {
      ${i(1, 1.125)}
    }
  }
`, C = e.div`
  ${g}

  .value {
    ${s}
  }
`, I = e(h)`
  ${m}
`, P = e(p)`
  ${m}
`, E = e(p)`
  ${d}
`, H = e(o)`
  width: 64px;
  height: 16px;
  min-width: 64px;
  height: 16px;
`, _ = e(o)`
  width: 100%;
  height: 20px;
`, M = e(o)`
  width: 102px;
  height: 24px;
  min-width: 102px;
  min-height: 24px;
`;
export {
  y as Container,
  b as Header,
  v as Info,
  C as Price,
  M as PriceSkeleton,
  I as ProductImage,
  P as ProductImageSkeleton,
  E as StoreImageSkeleton,
  H as StoreTextSkeleton,
  k as StoreWrapper,
  _ as TitleSkeleton
};
